import React, { useState, useEffect, useRef } from 'react';
// Navigation
import { useHistory, useLocation } from 'react-router-dom'
// Styles
import 'antd/dist/antd.css'
import '../dashboard.scss'
// antd
import { Button as AntButton, } from 'antd';
import { Card } from 'react-bootstrap';
import localStorage from "../../utils/localStorage";
// fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShare, faClock } from '@fortawesome/free-solid-svg-icons'
// Mui Components
import { Grid, useTheme, useMediaQuery, Box } from '@material-ui/core';
// Custom components
import DashboardLayout from '../../layouts/dashboardLayout'
import { AppBar, Button, PaginationBar, Navbar, NavbarSearch, ConfirmationModal, Table } from '../../customComponents'
// Constants
import { AppImages } from '../../themes/appImages'
import { Colors } from '../../themes/colors'
import { appConstants } from '../../themes/constants'
// utils methods
import cl from '../../utils/cl'
import { useStyles } from '../../styles'
// Redux
import { useSelector, useDispatch } from 'react-redux'
import { handleNavigationStateAction, getTerminalListAction, deleteTerminalAction, exportFileAction, importFileAction } from '../../store/actions'

export const TerminalListing = () => {
    const styleProps = { searchable: true }
    // Hooks declarations
    const classes = useStyles(styleProps);
    const theme = useTheme();
    const history = useHistory();
    const location = useLocation()
    const dispatch = useDispatch()
    const matches = useMediaQuery(theme.breakpoints.down('xs'));
    const terminalManagementstate = useSelector(state => state.terminalManagementReducer)
    let siderIndex = localStorage.getLayoutArr()
    // Global state initialization
    let permissionsData = localStorage?.getPermissions()
    let employeeIndex = permissionsData?.findIndex((x) => x.name == "terminal")
    const { terminalListing, terminalPaging, isLoading, deletedTerminal } = terminalManagementstate

    // local state initialization
    const [search, setSearch] = useState("")
    const [offset, setOffset] = useState(0)
    const [limit, setLimit] = useState(10)
    const [sortBy, setSortBy] = useState("")
    const [order, setOrder] = useState(null)
    const [confirm, setConfirm] = useState(false)
    const [terminalIdToDelete, setTerminalIdToDelete] = useState(null)
    const [disableButton, setDisableButton] = useState()
    // Method to fetch listing
    const fetchDataListing = (search, offset, limit, sortBy, order) => {
        dispatch(getTerminalListAction(search, offset, limit, sortBy, order))
    }
    let siderNestedIndex = localStorage.getNestedLayoutArr()
    //lifecycle hooks
    useEffect(() => {
        document.title = appConstants.headerTitle.terminalListing;
        if (permissionsData) {
            let index = siderIndex?.findIndex((x) => x.name == "Terminal Management")
            let nestedIndex = siderNestedIndex?.findIndex((x) => x.key == "terminal")
            dispatch(handleNavigationStateAction(index, false))
            setTimeout(() => {
                dispatch(handleNavigationStateAction(nestedIndex, true))
            }, 1000);
        }
        else {
            dispatch(handleNavigationStateAction(2, true))
        }
        fetchDataListing(search, offset, limit, sortBy, order)
    }, [])


    useEffect(() => {
        //      if( (offset+1) == terminalPaging?.page?.totalCount ){
        //     setOffset(offset-limit)
        //     fetchDataListing(search, 0, limit, sortBy, order)
        // }else{
        if (deletedTerminal !== null) {
            fetchDataListing(search, 0, limit, sortBy, order)
        }
        // }
    }, [deletedTerminal])


    //Callback method to handle sorting 
    const handleChange = async (pagination, filters, sorter) => {
        //To fetch listing in ascending order
        if (sorter.order == "ascend") {
            setOrder(1)
            setSortBy(sorter.columnKey)
            fetchDataListing(search, offset, limit, sorter.columnKey, 1)
        } //To fetch listing in descending order
        else if (sorter.order === "descend") {
            setOrder(-1)
            setSortBy(sorter.columnKey)
            fetchDataListing(search, offset, limit, sorter.columnKey, -1)
        } //To fetch listing in normal order
        else {
            setOrder(null)
            setSortBy("")
            fetchDataListing(search, offset, limit, "", null)
        }
    }

    // Callback method to handle page chage
    const handlePaginationChange = (e, page) => {
        const offsetTo = (page - 1) * limit
        setOffset(offsetTo)
        fetchDataListing(search, offsetTo, limit, sortBy, order)
    }

    // Callback method to handle searching key
    const handleSearching = async (e) => {
        var tempText = e.target.value
        if (e.target.value.charAt(0) === " ") {
            tempText = e.target.value.replace(/^ +/gm, '');

        }
        setSearch(tempText)
        fetchDataListing(tempText, 0, limit, "", null)
    }
    // +++++++++++

    const columns = [
        {
            title: appConstants.sr,
            dataIndex: '',
            key: 'sr',
            render: (text, record, index) => (index + 1) + (terminalPaging?.page?.nextPage - limit),
            ellipsis: false,
            width: 100,
        },
        {
            title: 'Terminal ID',
            dataIndex: 'terminal_id',
            key: 'terminal_id',
            render: (terminal_id) => terminal_id,
            ellipsis: false,
            sorter: true,
        },
        {
            title: 'Radar External ID',
            dataIndex: '_id',
            key: '_id',
            render: (_id) => _id,
            ellipsis: false,
            sorter: true,
        },
        {
            title: 'Terminal Logo',
            dataIndex: '',
            key: 'terminal_logo',
            align: 'center',
            render: (record) => {
                return (
                    <div className={classes.listingLogo}>
                        {record?.terminal_image_type == "url" ?
                            <img src={record?.terminal_url[0] && record?.terminal_url[0]} className={classes.terminalLogo} /> :
                            record?.terminal_logo ?
                                <img src={appConstants.baseURL + record?.terminal_logo}
                                    className={classes.terminalLogo} /> :
                                // <img src={record?.terminal_logo} className={classes.terminalLogo} /> :
                                <img src={AppImages.logo} className={classes.terminalLogo} />
                        }
                    </div>
                )
            },
            ellipsis: false,
        },
        {
            title: 'Terminal Name',
            dataIndex: 'terminal_name',
            key: 'terminal_name',
            render: (terminal_name) => terminal_name,
            ellipsis: false,
            sorter: true,
        },
        {
            title: 'Region Name',
            dataIndex: 'region_name',
            key: 'region_name',
            render: (region_name) => region_name,
            ellipsis: false,
            sorter: true,
        },
        {
            title: 'Terminal Location',
            dataIndex: 'terminal_location',
            key: 'terminal_location',
            render: (terminal_location) => <div
            style={{
                alignItems: "center",
                display: 'flex',
                // textOverflow: "ellipsis",
                maxWidth: "500px",
                whiteSpace: "pre-line",
                wordBreak: "break-all",
                width: "200px"
                // overflow: "hidden"
              }}
            >{terminal_location}</div>,
            ellipsis: false,
            sorter: true,
        },
        {
            title: 'Followers Count',
            dataIndex: 'followers_count',
            key: 'followers_count',
            render: (followers_count) => followers_count,
            ellipsis: false,
            sorter: true,
        },
        {
            title: 'Manage Wait Time',
            dataIndex: '',
            key: 'x',
            render: (record) => {
                return (
                    <Grid container justify="center">
                        <AntButton type="primary" shape="round" size="large" onClick={() => {
                            // history.push({ pathname: "/post", state: { terminalId: record._id } })
                            history.push({ pathname: "/manageWaitTime", state: { terminalId: record._id } })
                        }} className={classes.shareBtn}>
                             <FontAwesomeIcon icon={faClock} color={Colors.white} className={classes.shareIcon} />
                            {/* <FontAwesomeIcon icon={faShare} color={Colors.white} className={classes.shareIcon} /> */}
                        </AntButton>
                    </Grid>
                )
            },
        },
        {
            title: appConstants.action,
            dataIndex: '',
            key: 'x',
            width: 100,
            align: 'center',
            render: (record) => {
                return (
                    <Grid className={classes.buttons}>
                        <Button title={appConstants.edit}
                            disabled={(permissionsData) && permissionsData[employeeIndex]?.edit == false}
                            onClick={() => {
                                history.push({ pathname: "/edit-terminal", state: { terminalId: record._id } })
                            }} />
                        <Button disabled={(permissionsData) && permissionsData[employeeIndex]?.delete == false} title={appConstants.delete} onClick={() => {
                            setTerminalIdToDelete(record._id)
                            setConfirm(true)
                            setDisableButton(false)
                        }} />
                    </Grid>
                )
            },
        },
    ];

    return (
        <DashboardLayout>
            <ConfirmationModal
                title="Alert"
                text={appConstants.confirmDeleteTerminal}
                visible={confirm}
                disable={disableButton}
                onCancel={() => {
                    setTerminalIdToDelete(null)
                    setConfirm(false)
                }}
                onDeleteConfirmed={() => {
                    dispatch(deleteTerminalAction(terminalIdToDelete))
                    setConfirm(false)
                    setDisableButton(true)
                }}
            />
            <AppBar breadcrumbs={[{ route: '/terminals', name: "Terminal Listing" }]} />
            <Grid container className={classes.buttonBarWrapper}>
                <Button title="Add Terminal" disabled={(permissionsData) && permissionsData[employeeIndex]?.add == false} onClick={() => history.push('/add-terminal')} mr mb />
                <Button title="Export Terminal" onClick={() => dispatch(exportFileAction("terminal"))} mr mb />
                <Button title="Import Terminal" disabled={(permissionsData) && permissionsData[employeeIndex]?.edit == false} onClick={() => history.push('/import-terminal')} mr mb />
            </Grid>
            <Navbar title="Terminal Listing" searchable value={search} onChange={(e) => handleSearching(e)} />
            <Card className={classes.card}>
                {matches &&
                    <Box className={classes.searchBox}>
                        <NavbarSearch value={search} onChange={(e) => handleSearching(e)}
                        //  onPaste={alert('askd')} 
                        />
                    </Box>
                }
                <Grid container>
                    <Grid smUp={12} className={classes.tableContainerRow}>
                        <Table
                            loading={isLoading}
                            columns={columns}
                            dataSource={terminalListing}
                            onChange={handleChange}
                            searching={search.length > 0}
                        />
                    </Grid>
                </Grid>
                <PaginationBar
                    totalCount={terminalPaging?.page?.totalCount}
                    count={Math.ceil(terminalPaging?.page?.totalCount / limit)}
                    currentPage={terminalPaging?.page?.currentPage}
                    nextPage={terminalPaging?.page?.nextPage}
                    onChange={(e, page) => handlePaginationChange(e, page)}
                    prevPage={terminalPaging?.page?.nextPage - limit}
                />
            </Card>
        </DashboardLayout>
    );
}
